const resource = {
  "main": {
    "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 為你規劃訓練、記錄組數，並建議下一步。"])},
    "tagline": {
      "line1": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你的專屬 "])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI"])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 教練，陪伴每次訓練與每一餐。"])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line2": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line3": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["建立課表並記錄訓練。\n掌握下一步該練什麼。\n管理飲食並記錄每一餐。\n取得 AI 驅動的餐點評估。"])}
    },
    "previewImageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顯示訓練、飲食與 AI 教練功能的應用程式首頁"])},
    "signalLabels": {
      "aiPersonalizedRoutines": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 個人化課表"])},
      "nextWorkoutGuidance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下次訓練指引"])},
      "aiMealEvaluation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 餐點評估"])}
    }
  },
  "home": {
    "valueProps": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["為什麼選擇 AI Workout Coach"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["讓每次記錄成為下一次更好的訓練"])},
      "items": {
        "routine": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 個人化課表"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["依照你的目標與訓練程度，建立容易執行的課表。"])}
        },
        "insights": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["以你的資料進行分析"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["串連訓練、飲食與體重記錄，看見變化趨勢。"])}
        },
        "next": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清楚的下一步"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["根據你的記錄，瞭解下次訓練該調整的地方。"])}
        }
      }
    },
    "mealManagement": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["營養追蹤"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["每日營養狀態\n一目瞭然"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集中追蹤每一餐的熱量與巨量營養素。\n\n- 比較攝取量與每日目標\n- 查看碳水化合物、蛋白質與脂肪\n- 確認已完成記錄的餐點"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["營養追蹤應用程式畫面"])}
    },
    "mealInput": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 餐點分析"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["記錄餐點\n交給 AI 立即分析"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["加入照片或文字，即可獲得清楚的營養分析。\n\n- 幾秒內完成餐點記錄\n- 自動估算熱量與巨量營養素\n- 查看每一餐的 AI 評估"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用照片或文字記錄餐點並查看 AI 評估的應用程式畫面"])}
    },
    "about": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["智慧課表"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用智慧範本\n建立訓練課表"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["建立符合訓練方式的範本，之後可重複使用。\n\n- 依身體部位整理動作\n- 快速開啟常用課表\n- 不必每次重新設定即可開始訓練"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看課表分析"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顯示訓練課表範本的應用程式畫面"])}
    },
    "nutrition": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["進度洞察"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身體與訓練變化\n一目瞭然"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在同一畫面查看身體數據與訓練持續狀況。\n\n- 追蹤體重、肌肉量與體脂肪\n- 查看近期訓練活動\n- 找出需要留意的趨勢"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看進步分析"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顯示身體數據與近期訓練活動的應用程式畫面"])}
    },
    "weight": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訓練回顧"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["每次訓練後\n立即獲得回饋"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 會將本次訓練與近期紀錄進行比較。\n\n- 檢視組數、次數、重量與訓練量\n- 查看表現良好的部分\n- 瞭解下次需要調整之處"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看訓練回顧"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顯示已完成訓練之 AI 評估的應用程式畫面"])},
      "reviewCard": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["今日 AI 回顧"])},
        "metric": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+8%"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你的訓練量增加了"])},
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下次訓練維持目前重量，並增加一次反覆次數。"])}
      }
    },
    "aboutPro": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["長期分析"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["將訓練歷史\n整理成清楚摘要"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 串連多次訓練，呈現整體訓練方向。\n\n- 比較不同訓練的訓練量\n- 查看長期變化\n- 找出進步與不足之處"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看進步分析"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顯示訓練歷史 AI 摘要的應用程式畫面"])}
    },
    "formulas": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 評估每一次訓練"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 讀取所有訓練紀錄，標示你的狀態與改善方向。\n\n- 自動辨識運動類型\n- 分析次數、重量和訓練量\n- 根據近期紀錄提供回饋\n\n我們著重整體趨勢，而非單一組數。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看回饋"])}
    },
    "weightManagement": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["體重管理"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["記錄體重並\n掌握變化趨勢"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["將體重變化與訓練紀錄一起比較，並根據進度取得 AI 檢視。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顯示體重趨勢與 AI 檢視的體重管理應用程式畫面"])}
    },
    "downloadCta": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用自己的資料，讓訓練更聰明"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["將運動、飲食與體重紀錄集中管理，並根據你記錄的資料取得 AI 回饋。"])}
    }
  },
  "navigation": {
    "navbar": {
      "appTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI 訓練紀錄"])},
      "languages": {
        "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["英文"])},
        "de": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["德文"])},
        "es": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["西班牙文"])},
        "fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法文"])},
        "pt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["葡萄牙文"])},
        "zh-TW": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["繁體中文"])},
        "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["義大利文"])},
        "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["印尼文"])},
        "th": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["泰文"])},
        "ar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["阿拉伯文"])},
        "kr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["韓文"])},
        "jp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日文"])}
      },
      "subpages": {
        "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞭解更多"])},
        "appStore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App Store"])},
        "googlePlay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Google Play"])},
        "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公式"])},
        "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["書籍"])},
        "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["文章"])},
        "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["統計資料"])},
        "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["資訊"])},
        "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["贊助"])}
      }
    },
    "footer": {
      "copyrights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本網站使用的所有照片與標誌均無版權限制，並依 MIT 或 CC 授權提供。只要註明作者及來源，即可不受限制地使用、複製、修改或散布本網站的原始或修改內容。"])}
    }
  }
}
export default resource